import { UIHeading2, Button } from '@cian/ui-kit';
import * as React from 'react';

import { OtherServicesItem } from './parts';

import OfferIcon from './assets/offer.svg';
import * as style from './style.css';

interface IOtherServicesLayoutProps {
  testId: string;
  heading: string;
  showButton: boolean;
  onButtonClick: () => void;
  onLinkClick: () => void;
  children: React.ReactNode;
}

export const OtherServicesLayout: React.FC<IOtherServicesLayoutProps> = ({
  testId,
  heading,
  showButton,
  onButtonClick,
  onLinkClick,
  children,
}) => {
  return (
    <div data-testid={testId}>
      <UIHeading2 color="text-primary-default">{heading}</UIHeading2>

      <div className={style['offer-link']}>
        <OtherServicesItem
          singleItem
          title="Разместите объявление "
          description="Бесплатно для собственников жилой недвижимости"
          link="https://www.cian.ru/razmestit-obyavlenie/"
          icon={OfferIcon}
          onClick={onLinkClick}
        />
      </div>

      <div className={style['container']}>
        <div>{children}</div>

        {showButton && (
          <div className={style['button']}>
            <Button theme="fill_secondary" size="M" fullWidth onClick={onButtonClick}>
              Все сервисы
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
